import React, { useEffect, useState } from "react";
import TmsTable from "../../../../../components/tms-customs/tms-table";
import { withRouter } from "../../../../../utils/tms-with-router/tms-with-router";
import catchErrorFunction from "../../../../../utils/tms-catch-error/tms-catch-error";
import { Button, Checkbox, Col, Drawer, Row, Switch } from "antd";
import TmsTollGateService from "../../../../../services/tms-tollgate.service";
import "../../../../../assets/css/tms-darshanam/tms-d-inner-pages-all.scss";
import TmsTollgateInnerActions from "../../../../../components/tms-service-management/tms-tollgate/tms-sm-tollgate-inner-actions.jsx";
import TmsTollgateInnerPagesAND from "./tms-tollgate-inner-pages-and";
import TextArea from "antd/lib/input/TextArea";

const TmsTollgateInnerPagesAll = ({ router }) => {
  const [updateFlag, setUpdateFlag] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tollgateData, setTollgateData] = useState([]);
  const [tmsModalVisible, settmsModalVisible] = useState(false);
  const [viewTollgateData, setViewTollgateData] = useState();
  const [editFlag, setEditFlag] = useState();
  const [productId, setProductId] = useState();
  const [tableCurrentPage, setTabelCurrentPage] = useState(1);
  const [tablePageSize, setTabelPageSize] = useState(15);
  const [tableTotalSize, setTabelTotalSize] = useState(0);
  const [showDrawer, setShowDrawer] = useState(false);
  const [termsData, setTermsData] = useState([]);
  const [miniTicket, setMiniTicket] = useState(false);

  const tableColums = [
    ["Vehicle type", viewTollgateData?.name],
    ["Description", viewTollgateData?.description],
    ["Price", viewTollgateData?.price],
    [
      "Duration",
      viewTollgateData?.duration % 1440
        ? `${viewTollgateData?.duration / 1440} days`
        : viewTollgateData?.duration % 60
        ? `${viewTollgateData?.duration / 60} hours`
        : `${viewTollgateData?.duration} mins`,
    ],
    ["POS-(Status)", viewTollgateData?.counterEnabled ? "enabled" : "disabled"],
    [
      "Online-(Status)",
      viewTollgateData?.onlineEnabled ? "enabled" : "disabled",
    ],
  ];

  const switchTrigger = async (key, status, from) => {
    setLoading(true);
    try {
      const darData = await TmsTollGateService.viewTollGate(key);
      setViewTollgateData(darData);
      settmsModalVisible(true);
      setEditFlag(true);
      setProductId(key);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
    }
    // try {
    //   const tollgateData = await TmsTollGateService.viewTollGate(key);
    //   let body = {
    //     name: tollgateData?.name,
    //     description: tollgateData?.description,
    //     counterEnabled:
    //       from === "counter" ? status : tollgateData?.counterEnabled,
    //     onlineEnabled: from === "online" ? status : tollgateData?.onlineEnabled,
    //     price: tollgateData?.price,
    //     imageUrl: tollgateData?.imageUrl,
    //     duration: tollgateData?.duration,
    //   };
    //   await TmsTollGateService.editTollGate(key, body);
    //   setUpdateFlag(Math.random() + 1);
    // } catch (error) {
    //   catchErrorFunction(
    //     error,
    //     "Token Expired, redirecting to login page in 5 seconds",
    //     router
    //   );
    // }
    setLoading(false);
  };

  // eslint-disable-next-line no-unused-vars
  const handleTableChange = (pagination, filters, sorter) => {
    setTabelCurrentPage(pagination.current);
    setTabelPageSize(pagination.pageSize);
  };

  useEffect(() => {
    router.location?.pathname === "/service-management/toll-gate" &&
      getAllTollgate();
    if (!editFlag) {
      settmsModalVisible(false);
    }
  }, [
    updateFlag,
    editFlag,
    tableCurrentPage,
    tablePageSize,
    router.location?.pathname,
  ]);

  const getAllTollgate = async () => {
    setLoading(true);
    try {
      let data = [];
      setTollgateData([]);

      data = await TmsTollGateService.getTollGate(
        tableCurrentPage,
        tablePageSize
      );

      setTabelTotalSize(data?.meta?.totalItems);
      setTollgateData(
        data?.items?.map((item) => {
          return {
            key: item.id,
            ...item,
          };
        })
      );
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
    setLoading(false);
  };

  const columns = [
    {
      title: "Vehicle Type",
      dataIndex: "name",
      key: "name",
      //   ...getColumnSearchProps("darshanam_name"),
    },
    {
      title: "Duration",
      dataIndex: "duration",
      key: "duration",
      render: (record) => {
        return record % 1440 === 0
          ? `${record / 1440} days`
          : record % 60 === 0
          ? `${record / 60} hours`
          : `${record} mins`;
      },
    },
    {
      title: "Price",
      dataIndex: "price",
      key: "price",
      sorter: (a, b) => a.price > b.price,
      render: (text) => {
        return `Rs. ${text}`;
      },
    },

    {
      title: "POS-(Status)",
      dataIndex: "counterEnabled",
      key: "counterEnabled",
      render: (text, record) => {
        return (
          <Switch
            size={"small"}
            checked={text}
            style={{ background: text ? "#4CBB17" : "EFEFEF" }}
            onClick={() => {
              switchTrigger(record?.key, !text, "counter");
            }}
          />
        );
      },
    },
    {
      title: "Online-(Status)",

      dataIndex: "onlineEnabled",
      key: "onlineEnabled",
      render: (text, record) => {
        return (
          <Switch
            size={"small"}
            checked={text}
            style={{
              background: text ? "#4CBB17 " : "EFEFEF ",
            }}
            onClick={() => {
              switchTrigger(record?.key, !text, "online");
            }}
          />
        );
      },
    },
    {
      title: "Action",
      render: (record) => {
        return (
          <TmsTollgateInnerActions
            record={record}
            setLoading={setLoading}
            setViewTollgateData={setViewTollgateData}
            settmsModalVisible={settmsModalVisible}
            setUpdateFlag={setUpdateFlag}
            setEditFlag={setEditFlag}
            setProductId={setProductId}
            setShowDrawer={setShowDrawer}
            setTermsData={setTermsData}
            setMiniTicket={setMiniTicket}
          />
        );
      },
    },
  ];

  return (
    <>
      <TmsTable
        columns={columns}
        loading={loading}
        dataSource={tollgateData}
        handleTableChange={handleTableChange}
        pagination={{
          total: tableTotalSize,
          current: tableCurrentPage,
          pageSize: 10,
        }}
      />
      <Drawer
        className="DetailsModal"
        width={editFlag ? "800px" : "600px"}
        visible={tmsModalVisible}
        onClose={() => {
          settmsModalVisible(false);
          setEditFlag(false);
          setViewTollgateData(null);
        }}
        title={editFlag ? "Edit Tollgate" : "Tollgate Details"}
      >
        {editFlag ? (
          <TmsTollgateInnerPagesAND
            viewTollgateData={viewTollgateData}
            editFlag={editFlag}
            productId={productId}
            setEditFlag={setEditFlag}
            settmsModalVisible={settmsModalVisible}
          />
        ) : (
          <div className="viewDetails">
            <Col style={{ width: "100%" }}>
              <table className="DetailsTable">
                {tableColums.map((item) => {
                  return (
                    <tr key={"table" + item[0]}>
                      <th>{item[0]}</th>
                      <td>{item[1]}</td>
                    </tr>
                  );
                })}
              </table>
            </Col>
            <br />
            <Col className="ImgCol">
              <img src={viewTollgateData?.imageUrl} alt="Image" />
            </Col>
          </div>
        )}
      </Drawer>
      <Drawer
        className="TermsDrawer"
        visible={showDrawer}
        onClose={() => {
          setShowDrawer(false);
          setTermsData([]);
        }}
        title="Terms & Conditions"
        extra={
          <Button
            type="primary"
            onClick={async () => {
              setLoading(true);
              try {
                await TmsTollGateService.updateTerms(
                  productId,
                  termsData?.toString()?.replaceAll(",", "\n")?.split("\n"),
                  miniTicket
                );
                setUpdateFlag(Math.random() + 1);
                setShowDrawer(false);
                setTermsData([]);
                setMiniTicket(false);
              } catch (error) {
                catchErrorFunction(
                  error,
                  "Token Expired, redirecting to login page in 5 seconds",
                  router
                );
              }
              setLoading(false);
            }}
          >
            Submit
          </Button>
        }
      >
        <TextArea
          rows={4}
          value={termsData?.toString()?.replaceAll(",", "\n")}
          onChange={(e) => {
            setTermsData(e.target.value);
          }}
        />
        <Row className="formRow" style={{ width: "100%", paddingTop: "10px" }}>
          <Checkbox
            style={{ paddingRight: "10px" }}
            checked={miniTicket}
            onChange={(e) => setMiniTicket(e.target.checked)}
          />
          <label>Mini ticket</label>
        </Row>
      </Drawer>
    </>
  );
};

export default withRouter(TmsTollgateInnerPagesAll);
